import { ExternalLink, PopoverBasicHelp } from "@octopusdeploy/design-system-components";
import { ExternalLinkSlugs } from "~/areas/infrastructure/components/ArgoCDInstances/ArgoCDConstants";
export const ConfigurationMessages = {
    Name: {
        Validation: {
            AlreadyExists: "An Argo CD instance with this name already exists. Please choose a different name.",
            NotProvided: "Please enter a name for this Argo CD instance.",
            UnableToValidate: "Unable to validate if the name is unique. Please try again.",
        },
        HelperText: "You can use the same name as your Kubernetes cluster.",
    },
    Environments: {
        HelperText: "Scope this Argo CD instance to specific environments.",
    },
    ArgoCDUri: {
        Validation: {
            NotProvided: "Please enter the name & namespace of the Argo CD Server.",
            Invalid: "Please enter a valid Argo CD Server URL.",
        },
        HelperText: (<span>
                Provide the in-cluster URL for the Argo CD API server.{" "}
                <PopoverBasicHelp description={<p>
                            The format for a Kubernetes service DNS name is:
                            <br />
                            <strong>service-name.namespace.svc.cluster.local:service-port</strong>
                            <br />
                            <br />
                            The default DNS name for the Argo CD API server is:
                            <br />
                            <strong>argocd-server.argocd.svc.cluster.local</strong>
                        </p>} title={"Argo CD service DNS name"} width={"extra-wide"} link1={<ExternalLink href={"argo-cd-server-dns"}>Docs</ExternalLink>}/>
            </span>),
    },
    ArgoCDWebUiUri: {
        Validation: {
            Invalid: "Please enter a valid Argo CD Web UI URL.",
        },
        HelperText: "We\u2019ll use this to provide links to your Argo CD applications from the Octopus UI.",
    },
    ArgoCDAuthToken: {
        Validation: {
            NotProvided: "Please enter an authentication token.",
            Expired: "The JWT bearer token has expired.",
            Invalid: "Please enter a valid Argo CD JWT bearer token.",
        },
        HelperText: (<span>
                <ExternalLink href={ExternalLinkSlugs.ArgoCDAuthenticationDocs} size={"xSmall"}>
                    Follow the guide
                </ExternalLink>{" "}
                to create a new account and generate a token.
            </span>),
    },
    ServerUri: {
        Validation: {
            NotProvided: "Please enter the Octopus Deploy Server URL.",
            Invalid: "Please enter a valid Octopus Deploy Server URL.",
        },
        HelperText: "Provide the full URL to your Octopus Deploy instance.",
    },
    ServerGrpcUri: {
        Validation: {
            NotProvided: "Please enter the Octopus Deploy Server gRPC URL.",
            Invalid: "Please enter a valid Octopus Deploy Server gRPC URL.",
        },
        HelperText: "Provide the full gRPC URL to your Octopus Deploy instance.",
    },
} as const;
